import React, { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const Popup = ({ text, type, onClose, duration = 3000 }) => {
    const theme = useTheme();
    const [visible, setVisible] = useState(false);
    const [exiting, setExiting] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    let data = {};
    switch (type) {
        case 'success':
            data = { bg: theme.palette.green.bg, border: theme.palette.green.border, icon: <CheckCircleOutlineOutlinedIcon /> };
            break;
        case 'error':
            data = { bg: theme.palette.red.bg, border: theme.palette.red.border, icon: <ErrorOutlineOutlinedIcon /> };
            break;
        case 'delete':
            data = { bg: theme.palette.red.bg, border: theme.palette.red.border, icon: <DeleteOutlineOutlinedIcon /> };
            break;
        case 'update':
            data = { bg: theme.palette.blue.bg, border: theme.palette.blue.border, icon: <EditOutlinedIcon /> };
            break;
        default:
            data = { bg: theme.palette.green.bg, border: theme.palette.green.border };
            break
    }
    useEffect(() => {
        setVisible(true);
        const timeout = setTimeout(() => {
            setExiting(true);
            setTimeout(onClose, 500);
        }, duration);

        return () => clearTimeout(timeout);
    }, [duration, onClose]);

    return (
        <Box
            sx={{
                position: 'fixed',
                top: visible && !exiting ? '10px' : '-100px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1400,
                bgcolor: data.bg,
                color: theme.palette.common.white,
                px: isMobile ? 1 : 3,
                py: 0.8,
                borderRadius: 3,
                border: 1,
                borderColor: data.border,
                boxShadow: theme.shadows[4],
                opacity: visible && !exiting ? 1 : 0,
                transition: 'top 0.7s ease-in-out, opacity 0.7s ease-in-out',
                display: 'flex',
                width: isMobile ? '80%' : null
            }}
        >
            {data.icon}
            <Box width={10}> </Box>
            <Typography variant={isMobile ? "body2" : "body1"}>{text}</Typography>
        </Box>
    );
};

export default Popup;
